import React from 'react';
import { IntegrationProps } from '../types';

export const WatiSettings: React.FC<IntegrationProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4 animate-in fade-in">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">API Endpoint URL</label>
        <input
          type="text"
          value={config.endpoint || ''}
          onChange={(e) => onChange({ endpoint: e.target.value })}
          placeholder="https://live-server-XXXX.wati.io"
          className="w-full p-2 border rounded-lg"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Access Token</label>
        <input
          type="password"
          value={config.accessToken || ''}
          onChange={(e) => onChange({ accessToken: e.target.value })}
          className="w-full p-2 border rounded-lg"
        />
      </div>
    </div>
  );
};